import React, {useState} from 'react';

import {assert} from 'Asserts';
import {
  AnalyticsDashboardActions,
  cloneAnalyticsDashboard,
} from 'insights/analytics-dashboards/AnalyticsDashboardActions';
import AnalyticsProjectSelector, {
  getDefaultProjectId,
} from 'insights/shared/components/AnalyticsProjectSelector';
import navigateToURL from 'lib/navigateToURL';
import FormGroup from 'ui-library/bs/FormGroup';
import {ButtonStyle} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Modal from 'ui-library/modals/Modal';
import {withLoadingScreen} from 'util/Promises';

export type Actions = Pick<AnalyticsDashboardActions, 'cloneAnalyticsDashboard'>;

export interface CloneAnalyticsDashboardModalProps {
  actions: Actions;
  analyticsDashboardId: string;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export function CloneAnalyticsDashboardModal(props: CloneAnalyticsDashboardModalProps): JSX.Element {
  const [projectId, setProjectId] = useState(getDefaultProjectId());
  const canSubmit = projectId != null;

  async function handleSubmit(): Promise<void> {
    assert(projectId != null, 'Expected project for cloned dashboard');
    const clonedDashboard = await withLoadingScreen(
      props.actions.cloneAnalyticsDashboard(props.analyticsDashboardId, {projectId}),
      'Duplicating dashboard...'
    );
    navigateToURL(clonedDashboard.url);
    props.onRequestSubmit();
  }

  return (
    <Modal
      buttons={[{disabled: !canSubmit, style: ButtonStyle.SECONDARY, submit: true, text: 'Duplicate'}]}
      medium={true}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={handleSubmit}
      title="Duplicate dashboard"
    >
      <FormGroup>
        <FieldLabel label="Project" />
        <AnalyticsProjectSelector onChange={setProjectId} projectId={projectId} />
      </FormGroup>
    </Modal>
  );
}

export default function ConnectedCloneAnalyticsDashboardModal(
  props: Omit<CloneAnalyticsDashboardModalProps, 'actions'>
): JSX.Element {
  return <CloneAnalyticsDashboardModal {...props} actions={{cloneAnalyticsDashboard}} />;
}
